// The Main Site Object
window.Site = {

    slides      : document.querySelectorAll('.slide'),
    slideActive : document.querySelector('.slide.active'),

    // Init Function
    liftoff : () => {
        Site.moveSlider()
    },

    moveSlider : () => {
        setInterval(function(){

            Site.slideActive.classList.remove('active')
            Site.slideActive = Site.slideActive.nextElementSibling ?? Site.slides[0];
            Site.slideActive.classList.add('active')

        } , 3000);
    }

}

// Launch The Script
Site.liftoff()